import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { z } from "zod";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { addUserIntoProject } from "@backend/src/schemas/projectSchema";

type ProjectAddMemberResponseType = ResponseType<null>;

function useAssignUserToProjectMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<ProjectAddMemberResponseType>["response"],
    AxiosResponseAndError<ProjectAddMemberResponseType>["error"],
    {
      projectId: string;
      data: z.infer<typeof addUserIntoProject>;
    }
  >({
    mutationFn: (data) =>
      ApiRequest.put<ProjectAddMemberResponseType>(
        `${requestURLs.project}/userAssignIntoProject/${data.projectId}`,
        data.data
      ),
  });

  return mutation;
}

export default useAssignUserToProjectMutation;
